const PRO_MODE = {
    add: 'Add',
    update: 'Update'
  };
  const PRO_Config = {
    Add: {
      header: 'Add Pro',
      showProExcludedReason: true,
      showUpdateProStatusOptions: false,
      buttonLabel: 'Add Pro',
      proErrors: 'addProErrors'
    },
    Update: {
      header: 'Update Pro Status',
      showProExcludedReason: false,
      showUpdateProStatusOptions: true,
      buttonLabel: 'Update',
      proErrors: 'updateProErrors'
    }
  };
  
  export { PRO_MODE, PRO_Config };